import React from "react";
import { VaultObjectFilterController } from "@/components/vault/filter-controller/VaultObjectFilterController";
import { motion } from "motion/react";

export const ShowWindowTabContent = () => {
  return (
    <motion.div
      key={"vault-object-viewer-show-window-title"}
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <VaultObjectFilterController />
    </motion.div>
  );
};
